import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: "#FFF",
    padding: "0 0 0 10px",
    // borderRight: "1px solid #F2F2F2",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "0 0 0 10px",
  },
}));

function createData(name, calories, fat, carbs, protein, address, total) {
  return { name, calories, fat, carbs, protein, address, total };
}

const rows = [
  createData(
    "10-Jan-22",
    "Monday",
    "4.30PM",
    "10-Jan-22",
    "Monday",
    "6.30PM",
    "2hr 0min"
  ),
  createData(
    "10-Jan-22",
    "Monday",
    "4.30PM",
    "10-Jan-22",
    "Monday",
    "6.30PM",
    "2hr 0min"
  ),
  createData(
    "10-Jan-22",
    "Monday",
    "4.30PM",
    "10-Jan-22",
    "Monday",
    "6.30PM",
    "2hr 0min"
  ),
  createData(
    "10-Jan-22",
    "Monday",
    "4.30PM",
    "10-Jan-22",
    "Monday",
    "6.30PM",
    "2hr 0min"
  ),
  createData(
    "10-Jan-22",
    "Monday",
    "4.30PM",
    "10-Jan-22",
    "Monday",
    "6.30PM",
    "2hr 0min"
  ),
];

export default function DataTable() {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ height: 44 }}>
            <StyledTableCell align="left" sx={{ background: "#37465B" }}>
              Start Date
            </StyledTableCell>
            <StyledTableCell align="left" sx={{ background: "#5D687A" }}>
              Start Day
            </StyledTableCell>
            <StyledTableCell align="left" sx={{ background: "#37465B" }}>
              Start Time
            </StyledTableCell>
            <StyledTableCell align="left" sx={{ background: "#5D687A" }}>
              End Date
            </StyledTableCell>
            <StyledTableCell align="left" sx={{ background: "#37465B" }}>
              End Day
            </StyledTableCell>
            <StyledTableCell align="left" sx={{ background: "#5D687A" }}>
              End Time
            </StyledTableCell>
            <StyledTableCell align="left" sx={{ background: "#37465B" }}>
              Total Time
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow
              key={row.name}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                height: 30,
              }}
            >
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.name}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.calories}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.fat}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.carbs}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.protein}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.address}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.total}
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
